import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import {
  SdsForm,
} from "soft_digi";
import { HUBS_URLS } from "../../api/UserUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";
import {
  office_get_all_select,
  user_get_select,
} from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  sd_efl_office_id: Yup.object().required("Office City is required"),
  hub_id: Yup.string()
    .required("Hub ID is required"),
  role: Yup.array()
    .required("City In-charge is required")
    .min(1, "At least one role must be selected"),
  hub_name: Yup.string()
    .required("Hub Name is required")
    .max(50, "Hub Name must be at most 50 characters"),
  hub_capacity: Yup.number()
    .required("Hub Vehicle Capacity is required")
    .min(1, "Capacity must be at least 1")
,
  hub_area: Yup.string()
    .required("Hub Area is required")
  ,
  hub_rental: Yup.number()
    .required("Hub Rent is required")
    .min(0, "Rent must be at least 0")
    .max(1000000, "Rent must be at most 1,000,000"),
  latitude: Yup.string()
    .nullable(),

  longitude: Yup.string()
    .nullable()

});
const HubsForms: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const [allRole, setAllRole] = useState([]);
  const [allOffice, setAllOffice] = useState([]);
  const { closeModal } = useSiteContext();
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });
  
  useEffect(() => {
    user_get_select((data: any) => setAllRole(data));
    office_get_all_select((data: any) => setAllOffice(data));
  }, []);

  const onSubmit = (data: any) => {
    let url = HUBS_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = dataIn.ID;
      url = HUBS_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      showAlertAutoClose("Data Saved Successfully", "success");
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };
 

  const formElements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 6,
      name: "sd_efl_office_id",
      element: {
        label: "Office City",
        isRequired: true,
        options: allOffice,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "hub_id",
      element: {
        label: "Hub ID",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "SELECT_BOX",
      width: 6,
      name: "role",
      element: {
        label: "City In-charge",
        isRequired: true,
        options: allRole,
        isMulti: true,

        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "hub_name",
      element: {
        label: "Hub Name",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
        // validations: hubFormValidations.hub_name,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "hub_capacity",
      element: {
        label: "Hub Vehicle Capacity",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
        // validations: hubFormValidations.hub_capacity,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "hub_area",
      element: {
        label: "Hub Area",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
        //validations: hubFormValidations.hub_capacity,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "hub_rental",
      element: {
        label: "Hub Rent(Rs)",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
        //validations: hubFormValidations.hub_capacity,
      },
    },

    {
      type: "TEXT_BOX",
      width: 6,
      name: "latitude",
      element: {
        label: "Latitude",
        // isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
        // validations: hubFormValidations.lat,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "longitude",
      element: {
        label: "Longitude",
        //isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
        //  validations: hubFormValidations.lon,
      },
    },
    {
      type: "LABEL",
      width: 8,
      name: "label",
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-third-button"],
        label: "Close",
        onClick: closeModal,
      },
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      // class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-efl-input">
       
        <SdsForm elements={formElements} errors={errors} control={control} />
        {/* <div className="has-text-right">
          <SmartSoftButton
            label="Cancel"
            classList={["button", "mt-4 mr-4", "smart-third-button"]}
            onClick={closeModal}
          />
          <SmartSoftButton
            label={formData.ID ? "Update" : "Submit"}
            rightIcon="fa fa-arrow-right"
            classList={["button ", "mt-4", "smart-action-button"]}
            onClick={handleSubmit}
          />
        </div> */}
      </div>
    </>
  );
};

export default HubsForms;
